import React from 'react'
import { useTranslation, useI18next } from 'gatsby-plugin-react-i18next'

import JoinNewsletterForm from 'components/hubspot/joinNewsletterForm'
import { footerItems, productItems, widgetItems } from './footer.static'
import * as footerStyles from './footer.module.css'

const Footer = () => {
  const { t } = useTranslation()
  const { language } = useI18next()
  const currentYear = new Date().getFullYear()

  return (
    <footer className="bg-blue-300 text-white">
      <div className="container flex flex-col md:flex-row justify-center gap-x-5 py-14 md:py-7">
        <div className="w-full lg:w-1/5 py-7">
          {footerItems.solutions ? <p className={footerStyles.title}>{t('footer.category1.name')}</p> : null}
          {footerItems.solutions.map((listItem) => (
            <div key={listItem.name}>
              <div className={footerStyles.subtitle}>
                {listItem.href ? <a href={listItem.href}>{t(listItem.name)}</a> : <span>{t(listItem.name)}</span>}
              </div>
              {listItem.list ? (
                <ul className={footerStyles.mainList}>
                  {listItem.list.map((item) => (
                    <li key={item.name}>
                      <a href={item.href} rel={item.rel} target={item.target}>
                        {t(item.name)}
                      </a>
                    </li>
                  ))}
                </ul>
              ) : null}
            </div>
          ))}
        </div>
        <div className="w-full lg:w-2/5 py-7">
          {productItems ? <p className={footerStyles.title}>{t('footer.category2.name')}</p> : null}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-3">
            <div>
              <div className={`${footerStyles.subtitle} border-b border-white pb-1`}>{t(productItems.stream.name)}</div>
              {productItems?.stream?.list ? (
                <div>
                  {productItems.stream.list.map((listItem, listIndex) => (
                    <React.Fragment key={listIndex}>
                      <div className={`${footerStyles.subtitle} capitalize`}>{t(listItem.name)}</div>
                      <ul className={footerStyles.mainList} key={listIndex}>
                        {listItem.list.map((item, index) => (
                          <li key={index}>
                            <a
                              href={item.href}
                              className={item.href === '#' ? 'text-gray-400 pointer-events-none' : ''}
                            >
                              {t(item.name)}
                            </a>
                          </li>
                        ))}
                      </ul>
                    </React.Fragment>
                  ))}
                </div>
              ) : null}
            </div>
            <div>
              <div className={`${footerStyles.subtitle} border-b border-white pb-1`}>
                {t(productItems.application.name)}
              </div>
              {productItems?.application?.list ? (
                <div>
                  {productItems.application.list.map((listItem) => (
                    <React.Fragment key={listItem.name}>
                      <div className={`${footerStyles.subtitle} capitalize`}>{t(listItem.name)}</div>
                      <ul className={footerStyles.mainList}>
                        {listItem.list.map((item) => (
                          <li key={item.name}>
                            <a href={item.href}>{t(item.name)}</a>
                          </li>
                        ))}
                      </ul>
                    </React.Fragment>
                  ))}
                </div>
              ) : null}
            </div>
          </div>
        </div>
        <div className="w-full lg:w-2/5 grid grid-cols-1 py-7 md:grid-cols-2 gap-x-5">
          <div>
            {footerItems.resources ? <p className={footerStyles.title}>{t('footer.category3.name')}</p> : null}
            <ul className={footerStyles.mainList}>
              {footerItems.resources.map((item, index) => (
                <li key={index}>
                  <a href={item.href} rel={item.rel} target={item.target}>
                    {t(item.name)}
                  </a>
                  {item.list ? (
                    <ul className="list-disc pl-3">
                      {item.list.map((itemList) => (
                        <li key={itemList.name}>
                          <a href={itemList.href} rel={itemList.rel} target={itemList.target}>
                            {t(itemList.name)}
                          </a>
                        </li>
                      ))}
                    </ul>
                  ) : null}
                </li>
              ))}
            </ul>
          </div>
          <div>
            {footerItems.pricing ? <p className={footerStyles.title}>{t('footer.category4.name')}</p> : null}
            <ul className={footerStyles.mainList}>
              {footerItems.pricing.map((item, index) => (
                <li key={index}>
                  <a href={item.href}>{t(item.name)}</a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
      <div className="container border-b border-white py-3">
        <JoinNewsletterForm />
      </div>
      <div className="py-4">
        <div className="container flex flex-col md:flex-row md:items-center justify-between">
          <div className="flex">
            <img
              alt="Mlytics"
              src="https://www.mlytics.com/wp-content/uploads/2022/05/logo_Mlytics_white.svg"
              height="75"
              width="150"
              className="mr-2"
            />
            {widgetItems.slice(0, language === 'zh' ? 5 : 4).map((item) => (
              <a
                style={{ margin: 'auto 6px' }}
                key={item.alt}
                href={item.href}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img alt={item.alt} src={item.src} height="30" width="30" />
              </a>
            ))}
          </div>
          <p className="mt-4 md:mt-0">{t('footer.companyAnnouncementText', { year: currentYear })}</p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
